import { Lock, MicOff, Settings2 } from 'lucide-react';
import type { ReactNode } from 'react';
import type { BrowserName } from '@/lib/browserName.ts';
import { m } from '@/paraglide/messages.js';

export interface MicrophoneGuide {
  /** What the sketch of the browser bar highlights; null when there is no one place to point at. */
  marker: ReactNode | null;
  /** What the sketch shows next to it. */
  bar: string;
  steps: string[];
}

/**
 * How to allow the microphone again in this browser. Each one keeps the setting
 * somewhere else, and steps for the wrong browser are worse than none.
 */
export function microphoneGuide(browser: BrowserName, site: string): MicrophoneGuide {
  switch (browser) {
    case 'edge':
      return {
        marker: <Lock size={14} />,
        bar: site,
        steps: [
          m.practice_session_mic_blocked_edge_1(),
          m.practice_session_mic_blocked_edge_2(),
        ],
      };
    case 'chrome':
      return {
        marker: <Settings2 size={14} />,
        bar: site,
        steps: [
          m.practice_session_mic_blocked_chrome_1(),
          m.practice_session_mic_blocked_chrome_2(),
        ],
      };
    case 'safari':
      return {
        marker: 'Safari',
        bar: m.practice_session_mic_blocked_safari_menu({ site }),
        steps: [
          m.practice_session_mic_blocked_safari_1({ site }),
          m.practice_session_mic_blocked_safari_2(),
        ],
      };
    case 'firefox':
      return {
        marker: <MicOff size={14} />,
        bar: site,
        steps: [
          m.practice_session_mic_blocked_firefox_1(),
          m.practice_session_mic_blocked_firefox_2(),
        ],
      };
    case 'other':
      return {
        marker: null,
        bar: site,
        steps: [
          m.practice_session_mic_blocked_other_1(),
          m.practice_session_mic_blocked_other_2(),
        ],
      };
  }
}
